import { useParams } from "react-router-dom";
import type { StoreId } from "@KassaroAB/shared/types/ids";
import { UserRole } from "@KassaroAB/shared/types/enums/UserRole";
import { useGetUserQuery } from "../../query/usersQuery";

export const useHelpStoreId = (): StoreId | null => {
  const { storeId } = useParams<{ storeId: string }>();
  const { data: user } = useGetUserQuery();
  if (storeId) {
    return storeId as StoreId;
  }
  if (user?.role !== UserRole.USER) {
    return null;
  }
  const selected = localStorage.getItem("selectedStoreId");
  return selected ? (selected as StoreId) : null;
};
